import React from 'react';
import DiversedSpend from './ChartList/DiversedSpend';
import DiversedSuppliers from './ChartList/DiversedSuppliers';

const ChartsWrapper = () => {
	return (
		<>
			<DiversedSpend />
			<DiversedSuppliers />
		</>
	);
};

export default ChartsWrapper;
